import styled from '@emotion/styled';

export const StyledAffix = styled.div` // For more browser support, use: https://github.com/captivationsoftware/react-sticky
  position: -webkit-sticky; 
  position: sticky; 
  top: ${props => props.theme['padding-lg']};
`;
